import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'radio-cell',
  templateUrl: './radio-renderer.component.html',
  styleUrls: ['./radio-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RadioRendererComponent implements ICellRendererAngularComp {
  isSelected: boolean;
  params: any;

  constructor() {}

  initilize(params: ICellRendererParams) {
    if (params.data) {
      this.params = params;
      this.isSelected = params.getValue();
    }
  }

  onClick() {
    this.params.api.forEachNode(node => {
      if (node.data && node.data !== this.params.data) {
        node.data.isRadioSelected = false;
      }
    });
    this.params.data.isRadioSelected = true;
    this.isSelected = true;
    this.params.api.refreshCells({ force: true });
    this.params.node.setData(this.params.data);
    this.params.eGridCell.click();
  }

  onKeydown(event: KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.onClick();
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    if (params.data) {
      this.params = params;
      this.isSelected = params.data?.isRadioSelected || false;
    }
    return true;
  }
}
